interface BarcodeSvgProps {
  label: string;
  width: number;
  height: number;
}

function BarcodeSvg({ label, width, height }: BarcodeSvgProps) {
  // Rendu du code-barre imprimé sur le ticket : couleurs littérales
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ display: 'block' }}>
      <rect width={width} height={height} fill="#fff" stroke="#adb5bd" strokeWidth={1} />
      {Array.from({ length: 28 }, (_, i) => (
        <rect
          key={i}
          x={4 + i * 8}
          y={4}
          width={i % 3 === 0 ? 4 : 2}
          height={height - 18}
          fill={i % 4 === 0 ? '#adb5bd' : '#212529'}
          opacity={i % 4 === 0 ? 0.4 : 1}
        />
      ))}
      <text x={width / 2} y={height - 3} textAnchor="middle" fontSize={9} fill="#495057" fontFamily="monospace">
        {label}
      </text>
    </svg>
  );
}

export default BarcodeSvg;
